import { ButtonRole, ButtonSize } from "@components/Button";
import { Card } from "@components/Card";
import { ContactUsLink } from "@components/Link";
import { DonateModalButton } from "@components/layout/DonateButton";
import styled from "@emotion/styled";

import { spacing } from "@every.org/common/src/display/spacing";

import { verticalStackCss } from "src/theme/spacing";
import { FontWeight, textSizeCss } from "src/theme/text";

const MAX_TEXT_WIDTH = 600;

const StyledCard = styled(Card)`
  ${verticalStackCss.l};
  align-items: center;
  text-align: center;
  padding: ${spacing.xl} ${spacing.l};
  * {
    max-width: ${MAX_TEXT_WIDTH}px;
  }
  h2 {
    ${textSizeCss.l}
    font-weight: ${FontWeight.REGULAR};
  }
`;

interface FundAccountCardProps {
  donateOptions: {
    primarySlug: string;
    donationsEnabled: boolean;
    successUrl: string;
  };
}

export function FundAccountCard({ donateOptions }: FundAccountCardProps) {
  return (
    <StyledCard>
      <DonateModalButton
        data-tname="fundAccount"
        role={ButtonRole.PRIMARY}
        size={ButtonSize.MEDIUM}
        {...donateOptions}
      >
        Fund your DAF
      </DonateModalButton>
      <h2>Open a Donor-Advised Fund (DAF)</h2>
      <p>
        Unless you itemize your taxes, contributions to a Donor-Advised Fund
        (DAF) are not eligible for a charitable deduction.
      </p>
      <p>
        You&apos;ll get a donation receipt now, then you can use your balance to
        support all the nonprofits you want! Donating appreciated assets like
        stock or cryptocurrency to fund your Every.org account can be much more
        tax efficient, allowing you to give more and have more impact.
      </p>
      <p>
        For any questions, <ContactUsLink />.
      </p>
    </StyledCard>
  );
}
